import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { Moment } from 'moment';
import { ComponentRegistration } from '../../../core';
import { Dto, TransactionTypes, FrequentParkerActivityTypes } from '../../../data';
import { ICustomerSettingsService } from '../../../services';
import { IAccountAdminService } from './../services/accounts-service';
import { IUserAdminService } from './../';
import { IActivitiesService } from '../../dashboard';
let template = require('./account-detail.html');

class AccountDetailComponent extends ComponentRegistration {

    constructor() {
        super('accountDetail', {
            controller: AccountDetailController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {

            }
        });
    }
}

interface IAccountDetailController {

}

class AccountDetailController implements IAccountDetailController {
    private static $inject: Array<string> = ['$scope', '$mdToast', '$rootRouter', 'AccountAdmin', 'Activities', 'moment', 'CustomerSettings', 'UserAdmin'];
    private account: Dto.IAccount;
    private user: Dto.IProfile;
    private fpActivities: Array<Dto.IFrequentParkerActivity> = [];
    private keywords: string;
    private criteria: Dto.IFrequentParkerActivityCriteria;
    private fromDate: string;
    private toDate: string;
    private filteredActivities = [];
    private frequentParkerActivityTypes: Array<any>;
    private frequentParkerActivityType: string = null;
    private inEditMode: boolean = false;
    private originalAccount: Dto.IAccount;
    private adjustmentForm: ng.IFormController;
    private pointBalance: number;
    private totalManualAdjustments: number;
    private defaultPromotionSettings: Dto.IPromotionSettings;
    private adjustment: Dto.IAdjustment = {
        currencyType: 'points',
        creditAmount: null,
        debitAmount: null
    }

    //bindings

    constructor(private $scope: ng.IScope,
        private $mdToast: ng.material.IToastService,
        private $rootRouter: ng.Router,
        private AccountAdmin: IAccountAdminService,
        private Activities: IActivitiesService,
        private moment: Moment,
        private CustomerSettings: ICustomerSettingsService,
        private UserAdmin: IUserAdminService) {
        console.log("AccountDetailController loading");
    }



    public $onInit(): void {
        console.log("AccountDetailController loaded");

        this.frequentParkerActivityTypes = ng.copy(FrequentParkerActivityTypes)

        this.criteria = {
            pageSize: 25,
            pageNumber: 1

        } as Dto.IFrequentParkerActivityCriteria;

        this.CustomerSettings.getFrequentParkerSettings()
            .then((response) => {
                this.defaultPromotionSettings = Linq.From(response.settings.promotionSettings)
                    .FirstOrDefault(x => x.isDefault === true);
            });
    }

    public $routerOnActivate(next, previous) {
        // Get the account identified by the route parameter
        var id = next.params.id;

        return this.AccountAdmin.search({
            accountRuntimeIds: [id]
        } as Dto.IAccountCriteria).then((accounts) => {

            if (accounts.length > 0) {
                this.account = accounts[0];
                this.originalAccount = ng.copy(this.account);
                if (accounts[0].frequentParkerAccountId != null && !accounts[0].frequentParkerAccountId.isEmptyGuid()) {
                    this.criteria.frequentParkerAccountId = accounts[0].frequentParkerAccountId;
                    this.search(this.criteria);
                    this.getTotalAdjustments(accounts[0].frequentParkerAccountId);
                    this.getCurrentFppBalance(accounts[0].frequentParkerAccountId);
                }
                // Get the user entity assoicated with this account
                this.UserAdmin.search({ accountRuntimeIds: [this.account.id], accountId: this.account.id } as Dto.IProfileCriteria)
                    .then((users) => {
                        this.user = users[0];
                    });
            }
        });
    }

    public openMenu($mdMenu, ev) {
        $mdMenu.open(ev);
    };


    public search(criteria?: Dto.IFrequentParkerActivityCriteria): Promise<Dto.IFrequentParkerActivity[]> {
        return this.Activities.getFrequentParkerActivity(criteria).then((fpActivity) => {
            return this.fpActivities = fpActivity;
        });
    }

    public getCurrentFppBalance(frequentParkerAccountId: string): void {
        if (!frequentParkerAccountId || frequentParkerAccountId.isEmptyGuid()) return;
        let criteria = {
            pageNumber: 1,
            pageSize: 1,
            sortBy: "activityDateTime",
            sortDirection: "DESC",
            frequentParkerAccountId: frequentParkerAccountId

        } as Dto.IFrequentParkerActivityCriteria;

        this.Activities.getFrequentParkerActivity(criteria).then((fpActivity) => {
            this.pointBalance = ((fpActivity && fpActivity.length > 0)
                ? fpActivity[0] : {
                    beginPointBalance: 0,
                    endPointBalance: 0
                } as Dto.IFrequentParkerActivity).endPointBalance;
        });
    }

    public getTotalAdjustments(frequentParkerAccountId: string): void {
        if (!frequentParkerAccountId || frequentParkerAccountId.isEmptyGuid()) return;
        let criteria = {
            pageNumber: 0,
            pageSize: 0,
            sortBy: "activityDateTime",
            sortDirection: "DESC",
            activityType: 3,
            endDate: (this.moment as any)(Date.now()).format(),
            startDate: (this.moment as any)(Date.now()).add(-30, 'd').format(),
            frequentParkerAccountId: frequentParkerAccountId

        } as Dto.IFrequentParkerActivityCriteria;

        this.Activities.getFrequentParkerActivity(criteria).then((fpActivity) => {
            this.totalManualAdjustments = Linq.from(fpActivity).Sum(x => x.points || 0);
        });
    }


    public criteriaChanged(args) {
        this.criteria = args.criteria;
        this.search(this.criteria);
    }

    public onFilterChange(): void {
        this.search(this.criteria);
    }

    public onCreditApply(): void {
        this.adjustment.debitAmount = undefined;
        if (this.adjustment.currencyType === "points") {
            this.applyAdjustment(this.account.frequentParkerAccountId, this.adjustment);
        }
        else {
            this.adjustment.creditAmount = this.defaultPromotionSettings.pointAccruedPerDollar * this.adjustment.creditAmount;
            this.applyAdjustment(this.account.frequentParkerAccountId, this.adjustment);
        }

    }

    public onDebitApply(): void {
        this.adjustment.creditAmount = undefined;
        if (this.adjustment.currencyType === "points") {
            this.applyAdjustment(this.account.frequentParkerAccountId, this.adjustment);
        }
        else {
            this.adjustment.debitAmount = this.defaultPromotionSettings.pointsRedeemedPerDollar * this.adjustment.debitAmount;
            this.applyAdjustment(this.account.frequentParkerAccountId, this.adjustment);
        }
        //this.applyAdjustment(this.account.frequentParkerAccountId, this.adjustment);
    }

    protected applyAdjustment(frequentParkerAccountId, adjustment: Dto.IAdjustment): void {
        if (!frequentParkerAccountId || frequentParkerAccountId.isEmptyGuid()) return;
        this.Activities.addFrequentParkerAdjustment(frequentParkerAccountId, adjustment)
            .then(() => {
                this.onClear();
                this.criteria.pageNumber = 1;
                this.search(this.criteria);
                this.getTotalAdjustments(frequentParkerAccountId);
                this.getCurrentFppBalance(frequentParkerAccountId);
            });
    }

    public onReset(): void {
        this.filteredActivities = [];
        this.criteria.startDate = undefined;
        this.criteria.endDate = undefined;
        this.criteria.activityType = this.frequentParkerActivityTypes[0].value;
        this.criteria.pageNumber = 1;
        this.search(this.criteria);
    }

    public getActivityType(value) {
        var fpaType = Linq.from(this.frequentParkerActivityTypes)
            .FirstOrDefault(x => x.value === value);
        return fpaType ? fpaType.name : "";

    }

    public onClear(): void {
        this.adjustment.creditAmount = undefined;
        this.adjustment.debitAmount = undefined;
        this.adjustmentForm.$setUntouched();
    }

    public onCancel(args): void {
        this.account = ng.copy(this.originalAccount);
    }

    public onSave(args): void {
        this.AccountAdmin.update(this.account).then((account) => {
            this.account = account;
            this.originalAccount = ng.copy(account);
        });
    }

    public onEnterCredit(keyIdentifier): void {
        if (keyIdentifier === "Enter") {
            this.onCreditApply();
        }
    }

    public onEnterDebit(keyIdentifier): void {
        if (keyIdentifier === "Enter") {
            this.onDebitApply();
        }
    }

    public onResendInvite(): void {
        this.UserAdmin.sendInvite(this.user.userId, this.user.username)
            .then((response) => {
                var x = response;
            })
    }

    public onUnlockUser(): void {
        this.UserAdmin.unlockUser(this.user.userId);
    }
}

let accountDetailComponent = new AccountDetailComponent();
export default accountDetailComponent;
export { accountDetailComponent as AccountDetailComponent, IAccountDetailController, AccountDetailController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/account/account-detail.ts